export enum TrainingType {
    VISUAL = 'SL',
    MOTORIC = 'RL',
    EXPERT = 'EXPERT',
}
